export const SITE_TYPE = "SIXSHOP";

export const SIXSHOP_PAGE = {
  LOGIN: { target: `${SITE_TYPE}:LOGIN`, url: "/login" },
  SIGNUP: { target: `${SITE_TYPE}:SIGNUP`, url: "/signup" },
  FIND_PASSWORD: { target: `${SITE_TYPE}:FIND_PASSWORD`, url: "/findPassword" },
  MY_PAGE: { target: `${SITE_TYPE}:MY_PAGE`, url: "/myPage" },
  CHECK_GUEST_ORDER: {
    target: `${SITE_TYPE}:CHECK_GUEST_ORDER`,
    url: "/checkGuestOrder",
  },
  INTRO_ADULT_AUTH: {
    target: `${SITE_TYPE}:INTRO_ADULT_AUTH`,
    url: "/introAdultAuth",
  },
  PRODUCT_CATEGORY: {
    target: `${SITE_TYPE}:PRODUCT_CATEGORY`,
    url: "/shop",
    param: "productListFilter",
  },
  PRODUCT_DETAIL: { target: `${SITE_TYPE}:PRODUCT_DETAIL`, url: "/product" },
  CART: { target: `${SITE_TYPE}:CART`, url: "/cart" },
  ORDER: { target: `${SITE_TYPE}:ORDER`, url: "/order" },
  PAYMENT_REQUEST: {
    target: `${SITE_TYPE}:PAYMENT_REQUEST`,
    url: "/payment/request",
  },
  PAYMENT_SUCCESS: {
    target: `${SITE_TYPE}:PAYMENT_SUCCESS`,
    url: "/payment/success",
  },
  POLICY: { target: `${SITE_TYPE}:POLICY`, url: "/policy" },
  PRIVACY: { target: `${SITE_TYPE}:PRIVACY`, url: "/privacy" },
  SIGNUP_PRIVACY: {
    target: `${SITE_TYPE}:SIGNUP_PRIVACY`,
    url: "/signupPrivacy",
  },
} as const;
